/** Event envelope and stream topics. */
import { z } from 'zod';
import { uuid } from './common.js';

/** Envelope shared by `/stream` and outbound webhooks (api/openapi.yaml `Event`). */
export const EventEnvelope = z.object({
  id: z.string(),
  type: z.string(),
  occurredAt: z.string(),
  orgId: uuid,
  projectId: uuid.nullable(),
  subject: z.object({ type: z.string(), id: z.string() }),
  data: z.record(z.string(), z.unknown()),
});
export type EventEnvelope = z.infer<typeof EventEnvelope>;

/** `/stream?topics=` values (api/openapi.yaml). `integrations` carries inbound-delivery and provider events (P1). */
export const StreamTopic = z.enum(['builds', 'queue', 'submissions', 'approvals', 'credentials', 'env_vars', 'ota', 'integrations', 'shadow']);
export type StreamTopic = z.infer<typeof StreamTopic>;

export const TOPIC_OF_EVENT_PREFIX: Record<string, StreamTopic> = {
  'build.': 'builds', 'queue.': 'queue', 'submission.': 'submissions', 'approval.': 'approvals',
  'credential.': 'credentials', 'env_var.': 'env_vars', 'ota.': 'ota', 'inbound.': 'integrations', 'provider_account.': 'integrations',
  'shadow.': 'shadow',
};
export function topicOf(eventType: string): StreamTopic | undefined {
  const prefix = Object.keys(TOPIC_OF_EVENT_PREFIX).find((p) => eventType.startsWith(p));
  return prefix ? TOPIC_OF_EVENT_PREFIX[prefix] : undefined;
}
